import { Component } from '@angular/core';
import { Auth } from './../../shared/auth/auth.service';
@Component({
  selector: 'nvps-log-out',
  template: require('./log-out.component.html'),
})
export class LogOutComponent {
  constructor(private auth: Auth) {}

  logOut(): void {
    this.auth.logout();
  }
}
